
import React from 'react'; //import React Component
import { Navigate, Route, Routes } from "react-router-dom";
import { MainPage } from './MainPage';
import { Login } from './Login';
import { Signup } from './Signup';
import { Detail } from './Detail';
import { AddWelcome } from './AddWelcome';
import { AddProduct } from './AddProduct';
import { Profile } from './Profile';
import { Revise } from './Revise';
import { ReviseWelcome } from './ReviseWelcome';
import { SummaryPrice } from './SummaryPrice';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="main" />} />
        <Route path="*" element={<Navigate to="main" />} />
        <Route path="main" element={<MainPage />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="/food/:cardName" element={<Detail />} />
        <Route path="addWelcome" element={<AddWelcome />} />
        <Route path="addProduct" element={<AddProduct />} />
        <Route path="profile" element={<Profile />} />
        <Route path="/revise/:revise" element={<Revise />} />
        <Route path="/reviseWelcome/:revise" element={<ReviseWelcome />} />
        <Route path="summary" element={<SummaryPrice />} />
      </Routes>
    </div>
  );
}

export default App;